import { PUSH_LISTING_ESPOT_IMAGES_FOLDER, TOP_BANNER_ESPOT_IMAGES_FOLDER } from '@/constants/espot';
import { PUSH_LISTING_ESPOT_IMAGES_URL, PUSH_LISTING_ESPOT_IMAGES_WEBP, TOP_BANNER_ESPOT_IMAGES_URL } from '@/constants/urls';

export const getPushListingUrl = (isMobile, image) => {
  if (isMobile) {
    return `${PUSH_LISTING_ESPOT_IMAGES_URL}${PUSH_LISTING_ESPOT_IMAGES_FOLDER.MOBILE}${image}`;
  }

  return `${PUSH_LISTING_ESPOT_IMAGES_URL}${PUSH_LISTING_ESPOT_IMAGES_FOLDER.DESKTOP}${image}`;
};

export const getPushListingWebp = (isMobile, image) => {
  image = image.replace(/\.(jpg|jpeg|png)$/i, '.webp');
  if (isMobile) {
    return `${PUSH_LISTING_ESPOT_IMAGES_WEBP}${PUSH_LISTING_ESPOT_IMAGES_FOLDER.MOBILE}${image}`;
  }

  return `${PUSH_LISTING_ESPOT_IMAGES_WEBP}${PUSH_LISTING_ESPOT_IMAGES_FOLDER.DESKTOP}${image}`;
};

export const getTopBannerUrl = (image) => {
  return `${TOP_BANNER_ESPOT_IMAGES_URL}${TOP_BANNER_ESPOT_IMAGES_FOLDER.DESKTOP}${image}`;
};
